import { List, Text } from '@approvalmax/ui/src/components';

import { messages } from './Reasons.messages';

export const Reasons = () => {
    return (
        <>
            <Text font='body' fontSize='medium' fontWeight='regular'>
                {messages.inOrderToApprove}
            </Text>

            <Text font='body' fontSize='medium' fontWeight='regular'>
                {messages.providingDocuments}
            </Text>

            <Text font='body' fontSize='medium' fontWeight='bold'>
                {messages.theseCanBeUseful}
            </Text>

            <List listStyle='inside'>
                {[messages.balanceSheet, messages.annualStatement, messages.articlesOrCertificate].map(
                    (message, index) => (
                        <List.Item key={index}>{message}</List.Item>
                    )
                )}
            </List>

            <Text font='body' fontSize='medium' fontWeight='bold'>
                {messages.theseCanHelp}
            </Text>

            <List listStyle='inside'>
                {[
                    messages.corporateStructureChart,
                    messages.shareholderRegister,
                    messages.annualFinancialStatement,
                    messages.partnershipRegistration,
                    messages.partnershipAgreement,
                    messages.charitiesRegisterExtract,
                    messages.trustDeed,
                    messages.operatingAgreement,
                    messages.articlesOfIncorporation,
                    messages.stockCertificate,
                    messages.confirmationStatement,
                ].map((message, index) => (
                    <List.Item key={index}>{message}</List.Item>
                ))}
            </List>

            <Text font='body' fontSize='medium' fontWeight='bold'>
                {messages.theseCanHelpToUnderstand}
            </Text>

            <List listStyle='inside'>
                {[
                    messages.directorsRegister,
                    messages.financialStatement,
                    messages.partnershipRegistrationOrAgreement,
                    messages.charitiesDocument,
                    messages.operatingAgreement,
                    messages.corporateResolution,
                    messages.accountAuthorization,
                    messages.bylaws,
                    messages.confirmationStatement,
                ].map((message, index) => (
                    <List.Item key={index}>{message}</List.Item>
                ))}
            </List>
        </>
    );
};

Reasons.displayName = 'Reasons';
